import { Component, EventEmitter, OnInit, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IFertilizer } from '../interfaces';

@Component({
	moduleId: module.id,
	selector: 'fertilizer-list',
	templateUrl: 'fertilizer-list.html',
	styleUrls: [ 'fertilizer-list.scss' ]
})

export class FertilizerListComponent implements OnInit, OnChanges {

	@Input()
	public fertilizers: IFertilizer[];

	@Input()
	public showTypeTabs = false;

	@Input()
	public fertilizerTabIndex = 0;

	@Output()
	public fertilizerTabChange = new EventEmitter<number>();

	public filteredFertilizers: IFertilizer[];
	public searchQuery: string; // rename

	constructor() {
	}

	ngOnInit(): void {
		this._resetFilteredFertilizers();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.fertilizers) {
			this.searchQuery = '';
			this._resetFilteredFertilizers();
		}
	}

	public filterFertilizers(query: string): void {
		this.searchQuery = query;

		if (!this.fertilizers) {
			this.filteredFertilizers = [];
			return;
		}

		if (!this.searchQuery) {
			this.filteredFertilizers = this.fertilizers;
			return;
		}

		this.filteredFertilizers = this.fertilizers.filter(fertilizer =>
			fertilizer.Name.toLowerCase().includes(this.searchQuery.toLocaleLowerCase()));
	}

	public toggleSelectedFertilizer(fertilizer: IFertilizer): void {
		if (!fertilizer) {
			return;
		}

		if (fertilizer.checked === undefined || fertilizer.checked === false) {
			// assume this is getting checked.
			fertilizer.checked = true;
		} else {
			fertilizer.checked = false;
		}
	}

	private _resetFilteredFertilizers(): void {
		this.filteredFertilizers = this.fertilizers || [];
	}
}
